import {
  ACTIVITY_BY_PROJECT_LIST_FAIL,
  ACTIVITY_BY_PROJECT_LIST_REQUEST,
  ACTIVITY_BY_PROJECT_LIST_RESET,
  ACTIVITY_BY_PROJECT_LIST_SUCCESS,
  ACTIVITY_LIST_FAIL,
  ACTIVITY_LIST_REQUEST,
  ACTIVITY_LIST_RESET,
  ACTIVITY_LIST_SUCCESS,
  ACTIVITY_MARK_AS_READ_FAIL,
  ACTIVITY_MARK_AS_READ_REQUEST,
  ACTIVITY_MARK_AS_READ_RESET,
  ACTIVITY_MARK_AS_READ_SUCCESS,
  ACTIVITY_MARK_MESSAGES_AS_READ_FAIL,
  ACTIVITY_MARK_MESSAGES_AS_READ_REQUEST,
  ACTIVITY_MARK_MESSAGES_AS_READ_RESET,
  ACTIVITY_MARK_MESSAGES_AS_READ_SUCCESS,
  ACTIVITY_MESSAGE_CREATE_FAIL,
  ACTIVITY_MESSAGE_CREATE_REQUEST,
  ACTIVITY_MESSAGE_CREATE_RESET,
  ACTIVITY_MESSAGE_CREATE_SUCCESS,
} from '../constants/activityConstants'

export const activityListReducer = (state = { activities: [] }, action) => {
  switch (action.type) {
    case ACTIVITY_LIST_REQUEST:
      return { loading: true }
    case ACTIVITY_LIST_SUCCESS:
      return { loading: false, success: true, activities: action.payload }
    case ACTIVITY_LIST_FAIL:
      return { loading: false, error: action.payload }
    case ACTIVITY_LIST_RESET:
      return {}
    default:
      return state
  }
}

export const activityByProjectReducer = (
  state = { activities: [] },
  action
) => {
  switch (action.type) {
    case ACTIVITY_BY_PROJECT_LIST_REQUEST:
      return { loading: true }
    case ACTIVITY_BY_PROJECT_LIST_SUCCESS:
      return { loading: false, success: true, activities: action.payload }
    case ACTIVITY_BY_PROJECT_LIST_FAIL:
      return { loading: false, error: action.payload }
    case ACTIVITY_BY_PROJECT_LIST_RESET:
      return {}
    default:
      return state
  }
}

export const activitySendMessageReducer = (state = {}, action) => {
  switch (action.type) {
    case ACTIVITY_MESSAGE_CREATE_REQUEST:
      return { loading: true }
    case ACTIVITY_MESSAGE_CREATE_SUCCESS:
      return { loading: false, success: true }
    case ACTIVITY_MESSAGE_CREATE_FAIL:
      return { loading: false, error: action.payload }
    case ACTIVITY_MESSAGE_CREATE_RESET:
      return {}
    default:
      return state
  }
}

export const activityMarkAsReadReducer = (state = {}, action) => {
  switch (action.type) {
    case ACTIVITY_MARK_AS_READ_REQUEST:
      return { loading: true }
    case ACTIVITY_MARK_AS_READ_SUCCESS:
      return { loading: false, success: true }
    case ACTIVITY_MARK_AS_READ_FAIL:
      return { loading: false, error: action.payload }
    case ACTIVITY_MARK_AS_READ_RESET:
      return {}
    default:
      return state
  }
}

export const activityMarkMessagesAsReadReducer = (state = {}, action) => {
  switch (action.type) {
    case ACTIVITY_MARK_MESSAGES_AS_READ_REQUEST:
      return { loading: true }
    case ACTIVITY_MARK_MESSAGES_AS_READ_SUCCESS:
      return { loading: false, success: true }
    case ACTIVITY_MARK_MESSAGES_AS_READ_FAIL:
      return { loading: false, error: action.payload }
    case ACTIVITY_MARK_MESSAGES_AS_READ_RESET:
      return {}
    default:
      return state
  }
}
